<template>
  <div class="error-pages">
    <div
      :class="{
        'error-page': isErrorType === 'errorPage',
        'not-found': isErrorType === 'notFoundPage'
      }"
    >
      <svgicon
        v-if="isErrorType === 'errorPage'"
        :name="warning"
        :original="true"
      />
      <svgicon
        v-if="isErrorType === 'notFoundPage'"
        :name="noRes"
        :original="true"
      />
      <div>
        <h3 class="font-rubrik-1--bold">
          {{ errorHeader }}
        </h3>
        <p
          class="font-text-3--regular"
          v-html="errorPreamble"
        />
      </div>
    </div>

    <article
      v-if="viewPastSearches.length > 0 || clearedSearchHistory"
      class="result-categories search-result-padding"
    >
      <div class="result-categories-header-container">
        <header class="font-text-1--black search-category">
          Mina senaste sökningar
        </header>
        <header
          class="font-text-1--black search-category clear"
          @click="clear"
        >
          Rensa
        </header>
      </div>

      <template v-if="viewPastSearches.length > 0">
        <section
          v-for="(searches, key) in viewPastSearches"
          :key="key"
          :value="searches"
          class="result-categories__item not-found-page"
          @click="goToLastSearch(searches)"
          @keyup.enter="goToLastSearch(searches)"
        >
          <svgicon
            :name="search"
          />
          <span class="font-text-3--bold">{{ searches }}</span>
        </section>
      </template>

      <section
        v-else
        class="result-categories__item not-found-page"
      >
        <p class="font-text-3--bold">
          Dina senaste sökningar har tagits bort
        </p>
      </section>
    </article>
  </div>
</template>

<script>
import '#/Navigation/Search'
import '#/Alerts/Warning_illustrative'
import '#/Search/Search'

export default {
  props: {
    viewPastSearches: {
      type: Array,
      default: () => []
    },
    errorHeader: {
      type: String,
      default: ""
    },
    errorPreamble: {
      type: String,
      default: ""
    },
    isErrorType: {
      type: String,
      default: ""
    },
  },
  data () {
    return {
      search: 'Navigation/Search',
      warning: 'Alerts/Warning_illustrative',
      noRes: 'Search/Search',
      clearedSearchHistory: false
    }
  },
  methods: {
    goToLastSearch (searches) {
      this.$emit("gotolatestsearch", searches)
    },
    clear () {
      this.clearedSearchHistory = true
      this.$emit("clearlocalstorage")
    }
  }
}
</script>
<style lang="scss">

.error-pages {
  &::-webkit-scrollbar {
    display: none;
  }

  .not-found,
  .error-page {
    background-color: $color-blue-lightest;
    display: flex;
    align-items: center;
    color: $color-blue-dark;
    padding: 24px;

    @include media-breakpoint-up(lg) {
      padding: 32px;
    }

    svg {
      min-width: 61px;
      height: 61px;
      max-width: 61px;
      margin-right: 40px;
      margin-left: 16px;

      @include media-breakpoint-up(lg) {
        height: 55px;
        max-width: 55px;
      }
    }
  }

  .error-page {
    background-color: $color-red-special;
    color: $color-red-dark;
  }
}

</style>
